import { gql } from "lib/apolloClient";

export const impersonationUserFragment = {
  basicDetails: gql`
    fragment impersonationUserBasicDetailsItem on ImpersonationUser {
      id
      identityId
      firstName
      lastName
      type
      organization {
        id
        name
        logo
      }
      jwt
      designation {
        id
        title
      }
    }
  `,
};
